import { Box, Flex, Heading, Image, Stack, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link, useLoaderData } from "react-router";
import { useHydrated } from "../../hooks/useHydrated";
import { fetchEvents, toEventTypes } from "../../utils/events";
import { SideBar } from "../layout/Sidebar";
import { ErrorBoundary } from "../utils/ErrorBoundary";
import { EventButton } from "../utils/EventButton";
import { NavigationLoading } from "../utils/Loading";
import { OutletOrChildren } from "../utils/OutletOrChildren";
import { PageTitle } from "../utils/PageTitle";

export type IHomePageProps = Record<string, never>;

export async function loader() {
    return await fetchEvents();
}

export function HomePage() {
    const { t } = useTranslation();
    // Server-rendered markup must match the hydration render, so times are rendered
    // in UTC until the component has hydrated; only then are they converted to the
    // user's local timezone.
    const events = toEventTypes(useLoaderData<typeof loader>(), useHydrated());

    return (
        <VStack gap={0}>
            {/* <Flex
                position="absolute"
                w="100%"
                backgroundColor={useColorModeValue('brand.500', 'brand.400')}
                zIndex={10}
                h={10}
                m={0}
                alignItems={'center'}
                justifyContent={'center'}
                opacity={'90%'}
                gap={2}
            >
                <Icon as={RiAlertLine} fontSize={'20px'} color={'white'}></Icon>
                <Text color={'white'} textAlign={'center'}>
                    {t('home.WIP')}
                </Text>
            </Flex> */}
            <Flex
                direction={{ base: "column", sm: "row" }}
                w="100vw"
                h="100vh"
                bg={useColorModeValue("white", "gray.900")}
                color={useColorModeValue("gray.900", "gray.200")}
            >
                <SideBar />
                <Box flexGrow={1} flexShrink={1} position="relative" height="100%">
                    <NavigationLoading />
                    <Box height="100%" overflowX="hidden" overflowY="auto">
                        <ErrorBoundary>
                            <OutletOrChildren>
                                <Box>
                                    <Box position="relative" w="100%">
                                        <Image
                                            src="/images/headings/heading2.jpg"
                                            alt="heading-about"
                                            w="100%"
                                            h={{ base: 36, sm: 36, md: 56, lg: 72 }}
                                            objectFit="cover"
                                            objectPosition={"center center"}
                                            shadow={"md"}
                                        />
                                    </Box>

                                    <Stack
                                        direction={{ base: "column", md: "row" }}
                                        maxW={1536}
                                        p={10}
                                        alignItems={"flex-start"}
                                    >
                                        <VStack
                                            alignItems={"left"}
                                            maxW={1000}
                                            marginRight={{ base: 0, md: 10, xl: 20 }}
                                        >
                                            <PageTitle pageTitle="">{t("home.title")}</PageTitle>
                                            <Text marginBottom={5} fontSize="md">
                                                {t("about.paragraph1")}
                                            </Text>
                                        </VStack>
                                        {events.length > 0 && (
                                            <VStack alignItems={"left"}>
                                                <Link to="/events">
                                                    <Heading
                                                        fontSize="xl"
                                                        fontWeight={"semibold"}
                                                        color={useColorModeValue("brand.500", "brand.400")}
                                                        paddingBottom={3}
                                                    >
                                                        {t("events.upcomming")}
                                                    </Heading>
                                                </Link>
                                                <Stack
                                                    direction={{ base: "column", xl: "row" }}
                                                    alignItems={"left"}
                                                    gap={6}
                                                >
                                                    {events
                                                        .sort((a, b) => a.from.unix() - b.from.unix())
                                                        .slice(0, 3)
                                                        .map((event) => (
                                                            <Flex
                                                                key={event.from.unix() + event.link}
                                                                gap="12"
                                                                wrap="wrap"
                                                                paddingBottom={3}
                                                            >
                                                                <EventButton event={event} width="200px" />
                                                            </Flex>
                                                        ))}
                                                </Stack>
                                            </VStack>
                                        )}
                                    </Stack>
                                </Box>
                            </OutletOrChildren>
                        </ErrorBoundary>
                    </Box>
                </Box>
            </Flex>
        </VStack>
    );
}

export default HomePage;
export { Status as ErrorBoundary } from "../utils/Status";
